/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ url: NonNullable<unknown> }} Dialog_Link_Web_AddedInputs */

const en_dialog_link_web_added = /** @type {(inputs: Dialog_Link_Web_AddedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Added ${i?.url} to your library`)
};

const es_dialog_link_web_added = /** @type {(inputs: Dialog_Link_Web_AddedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Se agregó ${i?.url} a tu biblioteca`)
};

/**
* | output |
* | --- |
* | "Added {url} to your library" |
*
* @param {Dialog_Link_Web_AddedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_link_web_added = /** @type {((inputs: Dialog_Link_Web_AddedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Link_Web_AddedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_link_web_added(inputs)
	return en_dialog_link_web_added(inputs)
});